module.exports = __webpack_public_path__ + "media/images/category/feature/coj_d/hero-7bacc69a06f322ad8851e50351a173d2.jpg";